import PropTypes from 'prop-types';

import blushImg from './images/blush.png';
import carImg from './images/car.png';
import fireImg from './images/fire.png';
import heartImg from './images/heart.png';
import heartEyesImg from './images/heart_eyes.png';
import iphoneImg from './images/iphone.png';
import joyImg from './images/joy.png';
import thumbsUpImg from './images/thumbs_up.png';
import thumbsDownImg from './images/thumbs_down.png';
import poutingFace from './images/pouting_face.png';
import grinningSquintingFace from './images/grinning_squinting_face.png';
import explodingHead from './images/exploding_head.png';
import cryingFace from './images/crying_face.png';
import canBeBetter from './images/can_be_better.png';
import clappingHands from './images/clapping_hands.png';
import notWorking from './images/not_working.png';
import slightlyFrowningFace from './images/slightly_frowning_face.png';
import clown from './images/clown.png';

const emojiMap = {
  joy: joyImg,
  heart: heartImg,
  fire: fireImg,
  heart_eyes: heartEyesImg,
  smiling_face_with_heart_eyes: heartEyesImg,
  blush: blushImg,
  iphone: iphoneImg,
  car: carImg,
  thumbs_up: thumbsUpImg,
  thumbs_down: thumbsDownImg,
  pouting_face: poutingFace,
  grinning_squinting_face: grinningSquintingFace,
  exploding_head: explodingHead,
  crying_face: cryingFace,
  can_be_better: canBeBetter,
  clapping_hands: clappingHands,
  not_working: notWorking,
  slightly_frowning_face: slightlyFrowningFace,
  clown: clown,
};

export default function Emoji({ size, className, type }) {
  const emojiUrl = emojiMap[type];

  if (!emojiUrl) return null;

  return (
    <img
      alt={type}
      src={emojiUrl}
      width={size}
      height={size}
      className={className}
    />
  );
}

Emoji.defaultProps = {
  size: 18,
};

Emoji.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(emojiMap)),
};
